import { Box, Button, useTheme } from "@mui/material";
import React from "react";
import NorthWestIcon from "@mui/icons-material/NorthWest";
export function BorderedButton({
  children,
  sx,
  icon = true,
  onclick = () => console.log("clicked"),
}) {
  const theme = useTheme();

  const cornerStyle = {
    position: "absolute",
    width: { xs: "12px", md: "15px" },
    height: { xs: "12px", md: "15px" },
    border: "2px solid",
    borderColor: theme.palette.primary.main,
  };

  return (
    <Button
      aria-label="bordered-button"
      onClick={onclick}
      sx={{
        position: "relative",
        borderRadius: "1rem",
        px: 3,
        py: 1.2,
        ...sx,
      }}
    >
      {children}

      {icon && (
        <NorthWestIcon
          sx={{
            mr: ".5rem",
            fontSize: { xs: "1rem", sm: "1.2rem", md: "1.5rem" },
          }}
        />
      )}

      {/* Top Left */}
      <Box
        sx={{
          ...cornerStyle,
          top: 0,
          left: 0,
          borderRight: 0,
          borderBottom: 0,
          borderTopLeftRadius: "12px",
        }}
      />

      {/* Top Right */}
      <Box
        sx={{
          ...cornerStyle,
          top: 0,
          right: 0,
          borderLeft: 0,
          borderBottom: 0,
          borderTopRightRadius: "12px",
        }}
      />

      {/* Bottom Left */}
      <Box
        sx={{
          ...cornerStyle,
          bottom: 0,
          left: 0,
          borderRight: 0,
          borderTop: 0,
          borderBottomLeftRadius: "12px",
        }}
      />

      {/* Bottom Right */}
      <Box
        sx={{
          ...cornerStyle,
          bottom: 0,
          right: 0,
          borderLeft: 0,
          borderTop: 0,
          borderBottomRightRadius: "12px",
        }}
      />
    </Button>
  );
}
